import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../../zustand/ZustandContext";

const ProtectedRoute = () => {
    const auth = useAuthStore((state) => state.auth);
    return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
